import {
  IAugmentedJQuery,
  IComponentOptions,
  IController,
  IDocumentService,
  INgModelController,
  IScope,
  ITimeoutService
} from 'angular';
import { GmcSelectOptionController } from './components';
import './gmc-select2.component.scss';

export class GmcSelectController2 implements IController {
  static $inject = [
    '$element',
    '$document',
    '$scope',
    '$timeout'
  ];
  itemSelected: ( $event ) => void;
  isActive = false;
  value;
  placeholder = 'Please select';
  filter = false;
  maxHeight = 150;
  viewField: string;
  private inited = false;
  private selectedOption: GmcSelectOptionController;
  private ngModel: INgModelController;
  private options: GmcSelectOptionController[] = [];

  constructor( private $element: IAugmentedJQuery,
               private $document: IDocumentService,
               private $scope: IScope,
               private $timeout: ITimeoutService ) {
    this.parseValue = this.parseValue.bind(this);
    this.formatValue = this.formatValue.bind(this);
  }

  $onInit() {
    if ( this.viewField ) {
      this.filter = false;
    }
    this.initOutsideClickListener();
    this.ngModel.$render = () => {
      this.value = this.setValue(this.ngModel.$viewValue);
    };
    this.ngModel.$formatters.push(this.formatValue);
    this.ngModel.$parsers.push(this.parseValue);
  }

  $postLink() {
    this.$timeout(() => {
      const index = this.options.findIndex(( option ) => {
        return this.viewField
          ? option.value[ this.viewField ] === this.value
          : option.value === this.value;
      });
      if ( index > -1 ) {
        this.selectedOption = this.options[ index ];
        this.ngModel.$setViewValue(this.selectedOption);
        this.selectedOption.isSelected = true;
      }
      this.inited = true;
    });
  }

  onFocus() {
    this.isActive = true;
  }

  toggle() {
    this.isActive = !this.isActive;
    this.resetFilter();
  }

  selectOption( selectedOption: GmcSelectOptionController ) {
    this.options.forEach(( option ) => option.isSelected = false);
    this.selectedOption = selectedOption;
    this.selectedOption.isSelected = true;
    this.ngModel.$setViewValue(selectedOption);
    this.value = this.setValue(selectedOption.value);
    this.toggle();
  }

  onKeyUp( event ) {
    this.selectedOption = null;
    this.ngModel.$setViewValue(this.value);
    if ( this.filter ) {
      this.filterOptions(this.value);
    }
  }

  addOption( option: GmcSelectOptionController ) {
    this.options.push(option);
  }

  removeOption( targetOption: GmcSelectOptionController ) {
    this.options = this.options.filter(( option ) => option !== targetOption);
  }

  private setValue( value: any ): string {
    if ( typeof value === 'object' ) {
      return value[ this.viewField ];
    }
    return value;
  }

  private formatValue( value: any ) {
    this.changeActiveOption(value);
    if ( this.selectedOption ) {
      return this.viewField ? this.selectedOption.value[ this.viewField ] : this.selectedOption.value;
    }
    return value;
  }

  private parseValue( value: GmcSelectOptionController | string ) {
    if ( value instanceof GmcSelectOptionController ) {
      return value.value;
    }
    this.changeActiveOption(value);
    return value;
  }

  private changeActiveOption( value: any ) {
    if ( !this.inited ) {
      return;
    }
    this.$timeout(() => {
      this.options.forEach(( option ) => {
        option.isSelected = this.viewField
          ? value === option.value[ this.viewField ]
          : value === option.value;
      });
    });
  }

  private initOutsideClickListener() {
    this.$document.on('click', ( event: any ) => {
      if ( !this.isActive ) {
        return;
      }
      let target = event.target;
      let insideClick = false;
      while ( target ) {
        if ( target === this.$element[ 0 ] ) {
          insideClick = true;
        }
        target = target.parentNode;
      }
      if ( !insideClick ) {
        this.$scope.$apply(() => {
          this.isActive = false;
        });
      }
    });
  }

  private resetFilter() {
    if ( this.filter ) {
      this.filterOptions('');
    }
  }

  private filterOptions( term: string = '' ) {
    this.$timeout(() => {
      if ( term ) {
        this.options.forEach(( option ) => {
          const regexp = new RegExp(term, 'i');
          if ( regexp.test(option.value) ) {
            option.isVisible = true;
            if ( option.value.toLowerCase() === term.toLowerCase() ) {
              this.value = option.value;
              this.ngModel.$setViewValue(this.value);
            }
          } else {
            option.isVisible = false;
          }
        });
      } else {
        this.options.forEach(( option ) => {
          option.isVisible = true;
        });
      }
    });
  }
}

export const GmcSelectComponent2: IComponentOptions = {
  controller: GmcSelectController2,
  template: require('./gmc-select2.component.html'),
  transclude: {
    gmcSelectNoResults: '?gmcSelectNoResults'
  },
  require: {
    ngModel: 'ngModel'
  },
  bindings: {
    itemSelected: '&',
    placeholder: '@?',
    filter: '<?',
    maxHeight: '<?',
    viewField: '@'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-select-2/gmc-select2.component.ts